import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Snackbar } from '@cian/ui-kit';

import { setError } from '../../../actions/appStatus';
import { SNACKBAR_DELAY } from '../../../constants/delays';
import { selectError } from '../../../selectors/appStatus';

export const SnackbarContainer: React.FC = () => {
  const error = useSelector(selectError);

  const [isOpen, setOpen] = React.useState(false);
  const timeoutRef = React.useRef<number>();

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (error) {
      setOpen(true);

      timeoutRef.current = window.setTimeout(() => {
        setOpen(false);
        dispatch(setError(undefined));
      }, SNACKBAR_DELAY);
    }

    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, [error, dispatch]);

  if (!error) {
    return null;
  }

  // TODO: Перейти на новое API Snackbar, когда оно будет готово в ui-kit.
  return <Snackbar open={isOpen} size="M" status="error" message={error} autoHideDuration={SNACKBAR_DELAY} />;
};
